<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <app-b100-steps></app-b100-steps>
    <div class="information-margin"></div>

    <!-- 自治体団体登録・更新画面(入力)(B101) -->
    <div *ngIf="!confirmationFlag">
      <form [formGroup]="b101InputForm" autocomplete="off">
        <div class="input-form-information">
          <div class="form-content p-col-8 p-md-12 p-sm-12 information-Form">
            <div class="form-wraper">

              <!-- 団体組織区分 -->
              <div class="p-grid" *ngIf="b101InputForm.value.class_id != '9'">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">団体区分</label>
                </div>
                <div class="p-col-2 p-md-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-3 p-d-flex p-ai-center">
                  {{ className }}
                </div>
                <div class="p-col-6 p-md-9 error-message"></div>
              </div>

              <!-- 団体区分詳細 -->
              <div class="p-grid" *ngIf="b101InputForm.value.class_id != '9'">
                <div class="p-md-2 p-col-4 label-wraper">
                  <label class="item-input-name">団体区分詳細</label>
                </div>
                <div class="p-col-2 p-md-1 p-xxl-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-md-9 p-col-6 p-ai-center">
                  <p-dropdown [styleClass]="'readonly-lock'" inputId="installerId" optionLabel="name"
                    optionValue="value" styleClass="form-dropdown" formControlName="member_class_sub_id"
                    [options]="organizationList" placeholder="中学校" [showClear]="false"></p-dropdown>
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_class_sub_id')"></app-validator-message>
                </div>
              </div>

              <!-- 団体組織名 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 p-xxl-1 label-wraper">
                  <label class="item-input-name">団体名</label>
                </div>
                <div class="p-col-2 p-md-1 p-xxl-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-9 p-xxl-10">
                  <input title="団体名" class="member-form-input" type="text" pInputText [readonly]="true" [class.readonly-lock]="true"
                    formControlName="member_organization_name" autocomplete="off"
                    [ngClass]='checkInputMaxBoundary(b101InputForm,"member_organization_name")?"invalid-length":""' />
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message
                    [control]="b101InputForm.get('member_organization_name')"></app-validator-message>
                </div>
              </div>

              <!-- 設置者区分 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">設置者区分</label>
                </div>
                <div class="p-col-2 p-md-1 p-xxl-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-3 p-xxl-10">
                  <p-dropdown inputId="installerId" optionLabel="name" optionValue="value" styleClass="form-dropdown"
                    formControlName="member_installer_id" [options]="establisherTypeList" placeholder="国"
                    [showClear]="false"></p-dropdown>
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_installer_id')"></app-validator-message>
                </div>
              </div>

              <!-- 郵便番号 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">郵便番号</label>
                </div>
                <div class="p-col-2 p-md-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-3 p-xxl-10">
                  <input title="郵便番号" class="member-form-input" type="text" pInputText formControlName="member_postal_no"
                    [ngClass]='checkInputMaxBoundary(b101InputForm,"member_postal_no")?"invalid-length":""'
                    autocomplete="off" />
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_postal_no')"></app-validator-message>
                </div>
              </div>

              <!-- 都道府県 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">所在地(市区町村)</label>
                </div>
                <div class="p-col-2 p-md-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-3">
                  <p-dropdown inputId="city" optionLabel="name" optionValue="value" styleClass="form-dropdown"
                    formControlName="member_municipalities" [options]="postalNoList" placeholder="都道府県"
                    [showClear]="false" [filter]="true"></p-dropdown>
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_municipalities')"></app-validator-message>
                </div>
              </div>

              <!-- 所在地 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">所在地(それ以降の住所)</label>
                </div>
                <div class="p-col-2 p-md-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-9">
                  <input titile="所在地(それ以降の住所)" class="member-form-input" type="text" pInputText formControlName="member_address_building"
                    [ngClass]='checkInputMaxBoundary(b101InputForm,"member_address_building")?"invalid-length":""'
                    autocomplete="off" />
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message
                    [control]="b101InputForm.get('member_address_building')"></app-validator-message>
                </div>
              </div>

              <!-- 電話番号 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">電話番号</label>
                </div>
                <div class="p-col-2 p-md-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-3">
                  <input title="電話番号" class="member-form-input" type="text" pInputText formControlName="member_tel"
                    [ngClass]='checkInputMaxBoundary(b101InputForm,"member_tel")?"invalid-length":""'
                    autocomplete="off" />
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_tel')"></app-validator-message>
                </div>
              </div>

              <!-- メールアドレス -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">メールアドレス</label>
                </div>
                <div class="p-col-2 p-md-1 p-xxl-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-9">
                  <input title="メールアドレス" class="member-form-input" type="text" pInputText formControlName="member_email"
                    autocomplete="off" />
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_email')"></app-validator-message>
                </div>
              </div>

              <!-- 担当者氏名 -->
              <div class="p-grid">
                <div class="p-col-4 p-md-2 label-wraper">
                  <label class="item-input-name">担当者氏名</label>
                </div>
                <div class="p-col-2 p-md-1 p-xxl-1 required-end">
                  <span class="required">*必須</span>
                </div>
                <div class="p-col-6 p-md-9">
                  <input title="担当者氏名" class="member-form-input" type="text" pInputText formControlName="member_manager_name"
                    autocomplete="off" />
                </div>
                <div class="p-col-6 p-md-9 error-message">
                  <app-validator-message [control]="b101InputForm.get('member_manager_name')"></app-validator-message>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area p-mt-3">
        <button pButton type="button" label="確認画面へ" class="button-default-size button1" (click)="moveB102()"
          [disabled]="!b101InputForm.valid"></button>
      </div>
    </div>
    <!-- 自治体団体登録・更新画面(確認画面)(B102) -->
    <div class="input-form-information" *ngIf="confirmationFlag">

      <!-- 入力内容 -->
      <div class="form-content p-col-8 p-md-12 p-sm-12">
        <div class="form-wraper">
          <div class="p-grid" *ngIf="b101InputForm.value.class_id != '9'">
            <div class="p-col-4 p-md-2 label-wraper">
              <label for="school" class="school-label">団体区分</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-9 text-center label-wraper p-d-flex">
              {{ className }}
            </div>
          </div>

          <!-- 団体区分詳細 -->
          <div class="p-grid" *ngIf="b101InputForm.value.class_id != '9'">
            <div class="p-col-4 p-md-2 label-wraper">
              <label class="school-label">団体区分詳細</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-9 text-center label-wraper">
              {{ getNameByValue(this.organizationList, b101InputForm.value?.member_class_sub_id)}}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label for="school" class="school-label">団体名</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-9 text-center label-wraper">
              {{ b101InputForm.value?.member_organization_name }}
            </div>
          </div>

          <!-- 設置者区分 -->
          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label class="school-label">設置者区分</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-9 text-center label-wraper">
              {{ getNameByValue(this.establisherTypeList, b101InputForm.value?.member_installer_id)}}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label for="zip-code" class="zip-code-label">郵便番号</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-3 text-center label-wraper">
              {{ b101InputForm.value?.member_postal_no }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label for="address" class="address-label">所在地(市区町村)</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 text-center label-wraper">
              {{ getNameByValue(this.postalNoList, b101InputForm.value?.member_municipalities)}}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label for="city" class="city-label">所在地(それ以降の住所)</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-9 text-center label-wraper">
              {{ b101InputForm.value?.member_address_building }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label for="phone-number" class="phone-number-label">電話番号</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-3 text-center label-wraper">
              {{ b101InputForm.value?.member_tel }}
            </div>
          </div>

          <!-- メールアドレス -->
          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label class="school-label">メールアドレス</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-3 text-center label-wraper">
              {{ b101InputForm.value?.member_email }}
            </div>
          </div>

          <!-- 担当者氏名 -->
          <div class="p-grid">
            <div class="p-col-4 p-md-2 label-wraper">
              <label class="school-label">担当者氏名</label>
            </div>
            <div class="p-col-2 p-md-1 required-end">
              <span class="required">*必須</span>
            </div>
            <div class="p-col-6 p-md-3 text-center label-wraper">
              {{ b101InputForm.value?.member_manager_name }}
            </div>
          </div>
        </div>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area  p-mt-3">
        <button pButton type="button" label="登録する" class="btn-register button1" (click)="moveB103()"></button>
        <button pButton type="button" label="入力画面へ戻る" class="button2 btn-register" (click)="moveB101()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>